import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { ReferenceScheme } from '../models/reference-scheme.model';
import { ReferenceSchemeService } from '../services/reference-scheme.service';

@Injectable()
export class GetReferenceSchemeByIdResolver {
  constructor(private referenceSchemeService: ReferenceSchemeService) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.referenceSchemeService
      .getReferenceSchemeById(Number(route.paramMap.get('id')))
      .pipe(
        take(1),
        map((referenceScheme: ReferenceScheme) => referenceScheme),
      );
  }
}
